var $ = jQuery;
$(document).ready(function(){
    //form#subscribe-form should contain: input[name='email'], input[type='submit']
      $('form#subscribe-form').each(function(){
        $(this).submit(function(event){
          event.preventDefault();
          const submitBtn = $(this).find('input.subscribe-btn');
          submitBtn.css('cursor', 'wait');
          console.log('email:', event.target.email.value);
          $.post(
              _PHP.ajax_url, //send to /admin-ajax.php
              {
                  'action': 'subscirbe_with_nothing',
                  'email':event.target.email.value
              },
              function(response) {
                if(response.status == "ok"){
                    alert("Please check your email.");
                }else{
                    var error = response.error||"unknown error";
                    alert("Error: "+JSON.stringify(error));
                }
                submitBtn.css('cursor', 'pointer');
                $('#popout-subscribe').hide();
                if(window.fbq) fbq('trackCustom', 'SubscribeSucceed');
              }
          );
        });
      });

      $('form#subscribe-beamo').each(function(){
        $(this).submit(function(event){
          event.preventDefault();
          const submitBtn = $(this).find('input.subscribe-beamo-btn');
          submitBtn.css('cursor', 'wait');

          $.post(
              _PHP.ajax_url, //send to /admin-ajax.php
              {
                  'action': 'subscirbe_beamo',
                  'email': document.getElementsByClassName('subscribe-beamo-email')[0].value || document.getElementsByClassName('subscribe-beamo-email')[1].value
              },
              function(response) {
                if(response.status == "ok"){
                    if (_PHP.isTaiwan) {
                        alert("請點擊驗證信連結以加入訂閱！");
                    } else {
                        alert("Please click opt-in mail link to subscribe");
                    }
                }else{
                    var error = response.error||"unknown error";
                    alert("Error: "+JSON.stringify(error));
                }
                submitBtn.css('cursor', 'pointer');
                $('#popout-subscribe').hide();
                if(window.fbq) fbq('trackCustom', 'SubscribeSucceed');
              }
          );
        });
      });

    $('form#contact-us').each(function() {
        $(this).submit(function(event){
            event.preventDefault();
            const submitBtn = $(this).find('input.contact-us');
            submitBtn.css('cursor', 'wait');

            const itemId = {
                company: 'mce-COMPANY',
                name: 'mce-NAME',
                email: 'mce-EMAIL',
                category: 'mce-CATEGORY',
                phone: 'mce-PHONE',
                address: 'mce-ADDRESS-addr'
            }

            const getValue = (id) => {
                const value = document.getElementById(id).value;
                console.log(`getValue ${id}: ${value}`);
                return (value === '' ? null : value);
            }


            $.post(
                _PHP.ajax_url, //send to /admin-ajax.php
                {
                    'action': 'contact_us',
                    'company': getValue(itemId.company),
                    'name':  getValue(itemId.name),
                    'email': getValue(itemId.email),
                    'category': getValue(itemId.category),
                    'phone': getValue(itemId.phone),
                    'address': getValue(itemId.address)
                },
                function(response) {
                    if(response.status == "ok"){
                        alert("謝謝！客服團隊將儘速聯絡您！");
                    } else {
                        var error = response.error||"unknown error";
                        alert("Error: "+JSON.stringify(error));
                    }
                    submitBtn.css('cursor', 'pointer');
                    $('#popout-subscribe').hide();
                    if(window.fbq) fbq('trackCustom', 'SubscribeSucceed');
                }
            );
        });
    });

    $('form#contact-us-intl').each(function() {
        $(this).submit(function(event){
            event.preventDefault();
            const submitBtn = $(this).find('input.contact-us-intl');
            submitBtn.css('cursor', 'wait');

            console.log('=======');

            const itemId = {
                name: 'mce-NAME',
                phone: 'mce-PHONE',
                email: 'mce-EMAIL',
                individual: 'mce-MMERGE6-0',
                busness: 'mce-MMERGE6-1',
                country: 'mce-MMERGE2',
                partner: 'mce-MMERGE3',
                message: 'mce-MMERGE5',
                material: 'mce-MATERIAL',
            }

            const getValue = (id) => {
                const value = document.getElementById(id).value;
                console.log(`getValue ${id}: ${value}`);
                return (value === '' ? null : value);
            }

            const getType = () => {
                if (document.getElementById('mce-MMERGE6-0').checked && !document.getElementById('mce-MMERGE6-1').checked) {
                    return 'Individual';
                }

                if (!document.getElementById('mce-MMERGE6-0').checked && document.getElementById('mce-MMERGE6-1').checked) {
                    return 'Business';
                }

                return 'error';
            }

            const getModel = () => {
                const checked = [];

                if (document.getElementById('mce-group[20225]-20225-0').checked) {
                    checked.push('beamo');
                }

                if (document.getElementById('mce-group[20225]-20225-1').checked) {
                    checked.push('Beambox');
                }

                if (document.getElementById('mce-group[20225]-20225-2').checked) {
                    checked.push('Beambox Pro');
                }

                return checked.join(', ');
            }

            $.post(
                _PHP.ajax_url, //send to /admin-ajax.php
                {
                    'action': 'contact_us_intl',
                    'name':  getValue(itemId.name),
                    'phone': getValue(itemId.phone),
                    'email': getValue(itemId.email),
                    'customer_type': getType(),
                    'country': getValue(itemId.country),
                    'partner': getValue(itemId.partner),
                    'model': getModel(),
                    'material': getValue(itemId.material),
                    'message': getValue(itemId.message),
                },
                function(response) {
                    if(response.status == "ok"){
                        alert("Thank you for your time. We look forward to seeing you!");
                        document.location.href = '/partners';
                    } else {
                        var error = response.error||"unknown error";
                        const button = document.getElementById('mc-embedded-subscribe');
                        button.removeAttribute('disabled');
                        alert("Error: "+JSON.stringify(error));
                    }
                    submitBtn.css('cursor', 'pointer');
                    $('#popout-subscribe').hide();
                    if(window.fbq) fbq('trackCustom', 'SubscribeSucceed');
                }
            );
        });
    });
});
